export default {
  "luckWheelDailyStatisticsReport.title": "幸运轮盘每日统计报表",
  "luckWheelDailyStatisticsReport.column.no": "#序号",
  "luckWheelDailyStatisticsReport.column.userNo": "会员ID",
  "luckWheelDailyStatisticsReport.column.email": "邮箱",
  "luckWheelDailyStatisticsReport.column.name": "姓名",
  "luckWheelDailyStatisticsReport.column.inviterUserno": "邀请人编号",
  "luckWheelDailyStatisticsReport.column.inviterEmail": "邀请人邮箱",
  "luckWheelDailyStatisticsReport.column.inviterName": "邀请人姓名",
  "luckWheelDailyStatisticsReport.column.channel": "渠道",
  "luckWheelDailyStatisticsReport.column.referral": "推荐",
  "luckWheelDailyStatisticsReport.column.vipLevel": "VIP等级",
  "luckWheelDailyStatisticsReport.column.lastLoginIp": "最后登录IP",
  "luckWheelDailyStatisticsReport.column.bonusAmount": "奖金金额",
  "luckWheelDailyStatisticsReport.column.todayReceiveNum": "今日领取次数",
  "luckWheelDailyStatisticsReport.column.yesterdayReceiveNum": "昨日领取次数",
  "luckWheelDailyStatisticsReport.column.totalReceiveNum": "总领取次数",
  "luckWheelDailyStatisticsReport.column.lastReceiveTime": "最后领取时间",
  "luckWheelDailyStatisticsReport.search.createTime": "创建时间",
  "luckWheelDailyStatisticsReport.search.userNo": "会员ID",
  "luckWheelDailyStatisticsReport.search.email": "邮箱",
  "luckWheelDailyStatisticsReport.search.inviterUserno": "邀请人编号",
  "luckWheelDailyStatisticsReport.search.inviterEmail": "邀请人邮箱",
  "luckWheelDailyStatisticsReport.search.inviterFirstName": "邀请人名字",
  "luckWheelDailyStatisticsReport.search.inviterLastName": "邀请人姓氏",
  "luckWheelDailyStatisticsReport.search.vipLevel": "VIP等级",
  "luckWheelDailyStatisticsReport.tooltip.copy.userNo": "复制会员ID: {text}",
  "luckWheelDailyStatisticsReport.copy.success": "已复制到剪贴板",
  "luckWheelDailyStatisticsReport.search": "搜索",
};
